<div class="card pessoa-list-container">
    <p-toolbar styleClass="mb-4 pessoa-list-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple [disabled]="direitoInserir == false" label="Novo" icon="pi pi-plus"
                class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>

        <!-- <ng-template pTemplate="right">
            <div class="flex">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </div>
        </ng-template> -->
    </p-toolbar>

    <div class="pessoa-list-table-wrapper" #tableWrapper>
        <p-table #dt [value]="displayedPessoas" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="false" [lazy]="true" (onLazyLoad)="_fetchData($event)" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
            [showCurrentPageReport]="true" [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between gap-2">
                <h5 class="p-m-0">{{tituloPagina}}</h5>
                <div class="flex align-items-center gap-3 mt-2 md:mt-0">
                    <div *ngIf="tituloPagina === 'Clientes'" class="flex align-items-center gap-2">
                        <p-checkbox
                            inputId="mostrarDesativados"
                            [(ngModel)]="mostrarDesativados"
                            [binary]="true"
                            (onChange)="onMostrarDesativadosChange($event)">
                        </p-checkbox>
                        <label for="mostrarDesativados" class="mb-0 cursor-pointer">Mostrar desativados</label>
                    </div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="filterText"
                            placeholder="Pesquisar..." />
                    </span>
                </div>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Nome
                </th>
                <th>Tipo
                </th>
                <th>Data do cadastro
                </th>
                <th style="text-align: center;">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pessoa>
            <tr [class.row-desativado]="pessoa.ativo === false">
                <td><span class="p-column-title negrito">Código: </span>{{pessoa.id}}</td>
                <td><span class="p-column-title negrito">Nome: </span>{{pessoa.nome}}</td>
                <td><span class="p-column-title negrito">Tipo: </span>{{pessoa.tipo}}</td>
                <td><span class="p-column-title negrito">Data do cadastro: </span>{{pessoa.created_at | date:
                    'dd/MM/yyyy' }}</td>
                <td style="text-align: center;">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple icon="pi pi-pencil" [disabled]="direitoEditar == false"
                        class="p-button-rounded p-button-primary p-button-sm mr-2"
                        pTooltip="Editar" tooltipPosition="top" (click)="edit(pessoa)"></button>
                    <button pButton pRipple icon="pi pi-trash" [disabled]="direitoExcluir == false"
                        class="p-button-rounded p-button-danger p-button-sm"
                        pTooltip="Excluir" tooltipPosition="top" (click)="confirmarExclusao(pessoa)"></button>
                </td>
            </tr>
        </ng-template>

        </p-table>
    </div>
    <div class="col-12 card">
        <p-paginator [rows]="20" [totalRecords]="totalRecords" (onPageChange)="_fetchData($event)"></p-paginator>
    </div>
</div>

<!-- <p-dialog [(visible)]="tela_funcionarios" [style]="{width: '1000px'}" header="Funcionarios" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-fluid   ">
            <div [ngStyle]="{'margin': '7px'}">
                <form [formGroup]="form" class="p-fluid grid ">
                    <div class="field col-12 md:col-12 xl:col-6">
                        <p-floatlabel>
                            <input type="text" id="nome" pInputText required>
                            <label for="nome">Funcionário</label>
                        </p-floatlabel>
                    </div>
                    <div class="field col-12 md:col-12 xl:col-3">
                        <p-floatlabel>
                            <input type="text" id="email" pInputText required>
                            <label for="email">E-mail</label>
                        </p-floatlabel>
                    </div>
                    <div class="field col-12 md:col-12 xl:col-2">
                        <p-floatlabel>
                            <p-dropdown inputId="funcao_id" [autoDisplayFirst]="false">
                            </p-dropdown>
                            <label for="funcao_id">Função</label>
                        </p-floatlabel>
                    </div>

                    <div class="field col-12 md:col-12 xl:col-1">
                        <button pButton pRipple pTooltip="Novo funcionário" icon="pi pi-plus"
                            class="p-button-success"></button>
                    </div>
                </form>
            </div>

        </div>
        <p-table [value]="array_funcionarios" [columns]="cols_funcionarios" dataKey="id" [rows]="rows"
            styleClass="p-datatable-responsive-demo p-datatable-gridlines" [rowHover]="true">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="background-color: #efefef;" *ngFor="let col of columns">
                        {{col.header}}
                    </th>
                    <th style="background-color: #efefef; width: 10%; text-align: center;">
                        Remover
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td style="background-color: aliceblue;" *ngFor="let col of columns">
                        <span class="p-column-title">{{col.header}}</span>
                        {{rowData[col.field]}}
                    </td>
                    <td style="background-color: aliceblue; text-align: center;">
                        <button pButton pRipple icon="pi pi-trash" pTooltip="Remover Funcionário"
                            class="p-button-rounded p-button-danger"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>

    </ng-template>


    <ng-template pTemplate="footer">
        <button pButton pRipple label="Voltar" icon="pi pi-times" class="p-button-danger"
            (click)="tela_funcionarios = false"></button>
        <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-success"></button>
    </ng-template>
</p-dialog> -->
